import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

function Wishlist() {
  return (
    <>
        <Navbar/>
       <div className='Waitlist-div'>

       <div className='Waitlist'>
       <p>Your ultimate destination for celebrating cinema in all its glory.</p>
<h2>Join The Waitlist For Cine Celebrate Today</h2>
     
     <p>Be among the first to experience the magic! By joining our waitlist, you’ll get early access to exclusive updates, behind-the-scenes insights, and first dibs on everything Cine Celebrate has to offer.</p>
      <div className='join-ips'>
        <input placeholder='Your Email Address'/>
        <button>Join Waitlist</button>
      </div>
      
      
       </div>
       </div>

        <Footer/>
    </>
  )
}

export default Wishlist